import React, { PureComponent } from 'react';
import { connect } from 'react-redux';

import { removeBackgroundTask } from 'actions/background-tasks';
import Alert from './alert';

import IconCheckCircled from '../icons/icon-check-circled';

class BackgroundTaskProgress extends PureComponent {
    timeouts = [];
    errorTasks = [];

    state = {
        tasks: this.props.tasks
    }

    getTaskName(task) {
        switch (task.type) {
            case 'project_clone':
                return 'Duplicating project';

            case 'milestone_clone':
                return 'Duplicating milestone';

            case 'task_clone':
                return 'Duplicating task';

            case 'task_group_clone':
                return 'Duplicating task list';

            case 'task_group_convert':
                return 'Converting task list to milestone';

            case 'trello_import':
                return 'Importing from Trello';

            case 'asana_import':
                return 'Importing from Asana';

            case 'basecamp_import':
                return 'Importing from Basecamp';

            case 'tasks_move':
                return 'Moving all tasks';

            case 'tasks_remove':
                return 'Removing tasks';

            case 'project_template_create':
                return 'Creating project template';

            case 'project_create':
                return 'Creating project from template';

            default:
                return task.type;
        }
    }

    getTaskProgress(task) {
        if (task.completed) {
            return 1;
        }

        if (!task.current || !task.total) {
            return 0;
        }

        return Math.round((task.current / task.total) * 100) / 100;
    }

    getMessage(task) {
        const message = [];

        message.push(this.getTaskName(task));

        if (task.error) {
            message.push(' error');
        } else if (task.completed) {
            message.push(' completed');
        } else {
            const progress = this.getTaskProgress(task);

            if (progress) {
                message.push(': ', Math.round(progress * 100), '%');
            }

            message.push('...');
        }

        return message.join('');
    }

    addTasks(tasks) {
        if (!tasks.length) {
            return;
        }
        
        this.setState({
            tasks: [...this.state.tasks, ...tasks]
        });
    }

    updateTasks(tasks) {
        if (!tasks.length) {
            return;
        }

        if (tasks.some(task => !this.state.tasks.some(t => t.id === task.id))) {
            return;
        }

        this.setState({
            tasks: [...this.state.tasks].map(task => {
                const updatedTask = tasks.find(t => t.id === task.id);
                if (updatedTask) {
                    return updatedTask;
                }

                return task;
            })
        });
    }

    completeTasks(tasks) {
        if (!tasks.length) {
            return;
        }

        if (tasks.some(task => !this.state.tasks.some(t => t.id === task.id))) {
            setTimeout(() => this.completeTasks(tasks));
            return;
        }

        this.setState({
            tasks: [...this.state.tasks].map(task => {
                const completedTask = tasks.find(t => t.id === task.id);
                if (completedTask) {
                    return {
                        ...task,
                        completed: true
                    };
                }

                return task;
            })
        });

        this.timeouts.push(setTimeout(() => {
            this.removeTasks(tasks);
        }, 3000));
    }

    removeTasks(tasks) {
        if (!tasks.length) {
            return;
        }

        this.setState({
            tasks: this.state.tasks.filter(task => !tasks.some(t => t.id === task.id))
        });
    }

    clearErrorTasks(tasks) {
        if (!tasks.length) {
            return;
        }

        this.errorTasks = [...this.errorTasks, ...tasks.map(task => task.id)];

        this.timeouts.push(setTimeout(() => {
            this.removeTasks(tasks);
        }, 3000));

        tasks.forEach(task => removeBackgroundTask(task.id));
    }

    componentDidUpdate(prevProps) {
        if (prevProps.tasks !== this.props.tasks) {
            // New tasks
            const newTasks = this.props.tasks.filter(task => !prevProps.tasks.some(t => t.id === task.id));

            // Completed tasks
            const completedTasks = prevProps.tasks.filter(task => !this.props.tasks.some(t => t.id === task.id) && !this.errorTasks.includes(task.id));

            // Updated tasks
            const updatedTasks = this.props.tasks.filter(task => task !== prevProps.tasks.find(t => t.id !== task.id));

            // Error tasks
            const errorTasks = this.props.tasks.filter(task => task.error);

            this.addTasks(newTasks);
            this.updateTasks(updatedTasks);
            this.completeTasks(completedTasks);
            this.clearErrorTasks(errorTasks);
        }
    }

    componentWillUnmount() {
        this.timeouts.forEach(t => clearTimeout(t));
    }

    render() {
        return this.state.tasks.map(task => (
            <Alert
                key={task.id}
                collapsed={!task.completed && !task.error}
                progress={this.getTaskProgress(task)}
                type={task.error ? 'error' : 'success'}
                icon={task.error ? undefined : (task.completed ? <IconCheckCircled /> : <i className="icon material-icons icon-animate-rotate">autorenew</i>)}
             >
                { this.getMessage(task) }
            </Alert>
        ));
    }
}

const makeMapStateToProps = () => {
    return ({ backgroundTasks }) => ({
        tasks: backgroundTasks.tasks
    });
};

export default connect(makeMapStateToProps)(BackgroundTaskProgress);
